import { route } from 'quasar/wrappers/index.js'
import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes.js'
import { useAppStore } from 'src/stores/appStore.js'

export default route(() => {
    const router = createRouter({
        scrollBehavior: () => ({ left: 0, top: 0 }),
        routes,

        history: createWebHistory(import.meta.env.BASE_URL.replace('/build', '/')),
    })

    router.beforeEach(() => {
        const appStore = useAppStore()
        appStore.clearInterval()
    })

    return router
})
